export { default, InfoboxProps } from './Infobox';
